import React, { useEffect, useRef, useState } from 'react';
import Button from 'components/Button';
import SubscribeForm from 'components/Form/SubscribeForm';
import snackbar from 'utils/snackbar/snackbar';
import useGlobalFooter from 'hooks/useGlobalFooter';

import { SubscribeFormContainer } from './styles';

const SubNavSubscribeCTA = () => {
  const [isSubscribeOpen, setSubscribeOpen] = useState(false);
  const globalFooter = useGlobalFooter();
  const form = globalFooter?.form;
  const subscribeRef = useRef();

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const handleClick = e => {
    if (!subscribeRef?.current || subscribeRef.current.contains(e.target)) {
      return;
    }

    setSubscribeOpen(false);
  };

  const handleSubscribeSuccess = () => {
    setSubscribeOpen(false);
    snackbar(
      'Thanks for subscribing! Please check your email to confirm your subscription',
      'success'
    );
  };

  return (
    <SubscribeFormContainer>
      <Button
        className="subscribe-modal-button--button"
        type="secondary"
        onClick={() => setSubscribeOpen(true)}
      >
        Subscribe
      </Button>
      {isSubscribeOpen && (
        <div className="subscribe-modal-button--subscribe-container" ref={subscribeRef}>
          <SubscribeForm
            marketoForm={form.marketoForm}
            buttonType="secondary"
            notificationMessage="Thanks for subscribing!"
            shouldRedirect={false}
            onSuccess={handleSubscribeSuccess}
            dataPosition="Subnav"
            formType="Email Capture"
          />
        </div>
      )}
    </SubscribeFormContainer>
  );
};

export default SubNavSubscribeCTA;
